import React from "react";
import "./AboutSustainability.css";

function AboutSustainability(props) {
  return (
    <div className="AboutSustainability">
      <div className="about__Sustainability_container ">
        <div className="about__Sustainability_descriptioncontainer">
          <div
            id="Sustainability_descriptioncontainer"
            className="Sustainability_descriptioncontainer slow__hori__display"
          >
            <h2>Sustainability</h2>
            <p>
              ChildVision is designed in a way where sustainability is ensured
              along the way. By teaching in short blocks followed immediately by
              practical implementation, followed by assessment and then
              revision/correction of aspects taught, the model enables step by
              step progression. Solutions are sought that will enable OVC
              leaders to treat problems as stepping stones rather than
              obstacles. The principles of using what God has given you in your
              hands and hard work to transform your life, the lives of your
              family and those of your community are the key fundamental
              principles that enable sustainable transformation to take place.
              Training empowers OVC leaders to realize that through Jesus they
              are able to firstly transform their lives, secondly the lives of
              their family and thirdly the lives of their neighbours (the
              community). They therefore become sustainability transformation
              leaders in their communities.
            </p>
            <p>
              Another sustainability principle that is applied to the project is
              that of appropriate incentives. This includes OVC leaders being
              required to contribute to their own transformation costs (R250
              cash application fee + R2400 savings contribution + R1000
              contribution in kind for building a chicken enclosure + R500
              contribution in kind for building a vegetable garden) and the
              self-help savings groups where OVC leaders are required to
              “invest” their own money into a community “bank”. These kind of
              incentives stimulate a sense of ownership and thereby
              participation or buy-in that results in retention.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutSustainability;
